import { decryptResponseData } from "./Services/decryptApiResponse";
import { secureApiRequest } from "./Services/secureApiRequest";

const baseURL = process.env.REACT_APP_BASE_URL;

/**
 * Get the full URL for a file
 * - Supports direct uploads (/uploads/)
 * - Supports presigned S3 URLs
 * 
 * @param {string} fileName - File key or path
 * @returns {Promise<string>} - Full URL ready to use
 */
export const getFileUrl = async (fileName) => {
  if (!fileName) return "";

  try {
    // case 1: local uploads
    if (fileName.startsWith("/uploads/")) {
      return baseURL + fileName;
    }

    // case 2: needs presigned URL
    const response = await secureApiRequest("post", "masters/preSigned-signature", {
      key: fileName,
    });
    const dec_data = decryptResponseData(response);
    return dec_data?.data?.presignedURL || "";
  } catch (error) {
    console.error("Error getting file URL:", error);
    return "";
  }
};
